import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authApi } from '../lib/api'

function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    console.log('=== FORGOT PASSWORD FORM SUBMITTED ===')
    console.log('Email:', email)
    setError('')
    setSuccess(false)
    setIsLoading(true)

    try {
      console.log('Calling authApi.forgotPassword...')
      const result = await authApi.forgotPassword(email)
      console.log('Success:', result.data)
      setSuccess(true)
    } catch (err: any) {
      console.error('Forgot password error:', err)
      console.error('Error config:', err.config)
      console.error('Error response:', err.response)
      setError(err.response?.data?.error || err.message || 'Failed to send reset email')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bg-primary)', '--bg-primary': '#F7FAF7', '--forest-green': '#1B5E20', '--emerald': '#2E7D32', '--bg-tint': '#E8F5E9', '--slate': '#4A5568', '--slate-light': '#718096', '--border': '#E2E8F0', '--text-primary': '#1A202C', '--text-secondary': '#4A5568', '--text-muted': '#A0AEC0', '--success-bg': '#C6F6D5', '--success-text': '#276749', '--success-border': '#9AE6B4', '--error-bg': '#FED7D7', '--error-text': '#C53030', '--error-border': '#FC8181'} as React.CSSProperties}>
      <header style={{background: '#fff', borderBottom: '1px solid var(--border)', padding: '1rem 2rem'}}>
        <Link to="/" style={{fontSize: '1.5rem', fontWeight: 700, color: 'var(--forest-green)', textDecoration: 'none'}}>
          I Got That U.S.
        </Link>
      </header>

      <main style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem'}}>
        <div style={{width: '100%', maxWidth: '400px', background: '#fff', padding: '2rem', borderRadius: '12px', boxShadow: 'var(--shadow)'}}>
          <h1 style={{fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--text-primary)'}}>Reset Password</h1>
          <p style={{color: 'var(--text-secondary)', marginBottom: '1.5rem'}}>Enter your email and we'll send you a reset link</p>

          {success ? (
            <div style={{padding: '1rem', background: 'var(--bg-tint)', borderRadius: '8px', marginBottom: '1rem'}}>
              <p style={{color: 'var(--forest-green)', margin: 0}}>Check your email for reset instructions!</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && (
                <div style={{padding: '0.75rem', background: 'var(--error-bg)', borderRadius: '8px', marginBottom: '1rem', color: 'var(--error-text)', border: '1px solid var(--error-border)'}}>
                  {error}
                </div>
              )}

              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', fontSize: '0.875rem', fontWeight: 500, color: 'var(--text-secondary)', marginBottom: '0.5rem'}}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                  style={{width: '100%', padding: '0.75rem', border: '1px solid var(--border)', borderRadius: '8px', fontSize: '1rem'}}
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                style={{width: '100%', padding: '0.875rem', background: 'var(--forest-green)', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: 600, cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.7 : 1}}
              >
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <p style={{textAlign: 'center', marginTop: '1.5rem', color: 'var(--text-secondary)'}}>
            Remember your password?{' '}
            <Link to="/login" style={{color: 'var(--forest-green)', fontWeight: 600, textDecoration: 'none'}}>Sign in</Link>
          </p>
        </div>
      </main>
    </div>
  )
}

export default ForgotPassword
